import { useLocation, Routes, Route } from 'react-router-dom';

import Home from '../pages/Home';
import Services from '../pages/Services';
import TelephonieIP from '../pages/TelephonieIP';
import TelephonieSMS from '../pages/TelephonieSMS';
import TelephonieFax from '../pages/TelephonieFax';
import TelephonieEquipements from '../pages/TelephonieEquipements';
import Offres from '../pages/Offres';
import Actualites from '../pages/Actualites';
import Technologies from '../pages/Technologies';
import Simplicite from '../pages/Simplicite';
import APropos from '../pages/APropos';
import Support from '../pages/Support';
import Contact from '../pages/Contact';
import TransfertTelephone from '../pages/TransfertTelephone';
import PolitiqueConfidentialite from '../pages/PolitiqueConfidentialite';

export default function AnimatedRoutes() {
  const location = useLocation();

  return (
    <div key={location.pathname} className="page-transition">
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/telephonie-ip" element={<TelephonieIP />} />
        <Route path="/telephonie-ip/sms" element={<TelephonieSMS />} />
        <Route path="/telephonie-ip/fax" element={<TelephonieFax />} />
        <Route path="/telephonie-ip/equipements" element={<TelephonieEquipements />} />
        <Route path="/offres" element={<Offres />} />
        <Route path="/actualites" element={<Actualites />} />
        <Route path="/technologies" element={<Technologies />} />
        <Route path="/simplicite" element={<Simplicite />} />
        <Route path="/a-propos" element={<APropos />} />
        <Route path="/support" element={<Support />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/transfert-telephone" element={<TransfertTelephone />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
      </Routes>
    </div>
  );
}